<app-results-header [blank]="true" [page]="'search'"></app-results-header>

@if (user) {
  <div class="profile_information--container" id="main">
    <div class="profile_information--tabs">
      @if (userProfileConfig.profile !== profileConfigOption.Hidden) {
        <div
          class="profile_information--tab"
          [ngClass]="{ 'profile_information--tab--selected': tabSelected === 0 }"
          (click)="tabSelected = 0"
        >
          <fa-icon [icon]="faUser"></fa-icon>
          <span i18n="@@profile-tab">Profile</span>
        </div>
      }
      @if (userProfileConfig.address !== profileConfigOption.Hidden) {
        <div
          class="profile_information--tab"
          [ngClass]="{ 'profile_information--tab--selected': tabSelected === 1 }"
          (click)="tabSelected = 1"
        >
          <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
          <span i18n="@@address-tab">Address</span>
        </div>
      }
      @if (userProfileConfig.miDefault !== profileConfigOption.Hidden) {
        <div
          class="profile_information--tab"
          [ngClass]="{ 'profile_information--tab--selected': tabSelected === 2 }"
          (click)="tabSelected = 2"
        >
          <fa-icon [icon]="faListAlt"></fa-icon>
          <span i18n="@@mi-default-tab">MI Default</span>
        </div>
      }
      @if (userProfileConfig.documents !== profileConfigOption.Hidden) {
        <div
          class="profile_information--tab"
          [ngClass]="{ 'profile_information--tab--selected': tabSelected === 3 }"
          (click)="tabSelected = 3"
        >
          <span i18n="@@docs-tab">Docs</span>
        </div>
      }
      @if (userProfileConfig.loyalty !== profileConfigOption.Hidden) {
        <div
          class="profile_information--tab"
          [ngClass]="{ 'profile_information--tab--selected': tabSelected === 4 }"
          (click)="tabSelected = 4"
        >
          <span i18n="@@loyalty-tab">Loyalty</span>
        </div>
      }
      @if (userProfileConfig.travelPreferences !== profileConfigOption.Hidden) {
        <div
          class="profile_information--tab"
          [ngClass]="{ 'profile_information--tab--selected': tabSelected === 5 }"
          (click)="tabSelected = 5"
        >
          <span i18n="@@travel-preferences-tab">Travel Preferences</span>
        </div>
      }
      @if (user.approver && userProfileConfig.approvers !== profileConfigOption.Hidden) {
        <div
          class="profile_information--tab"
          [ngClass]="{ 'profile_information--tab--selected': tabSelected === 7 }"
          (click)="tabSelected = 7"
        >
          <span i18n="@@approval-tab">Approval</span>
        </div>
      }
      @if (user.approver && userProfileConfig.approvalReassignment !== profileConfigOption.Hidden) {
        <div
          class="profile_information--tab"
          [ngClass]="{ 'profile_information--tab--selected': tabSelected === 6 }"
          (click)="tabSelected = 6"
        >
          <span i18n="@@approval-reassignment-tab">Approval Reassignment</span>
        </div>
      }
      @if (userProfileConfig.payment !== profileConfigOption.Hidden) {
        <div
          class="profile_information--tab"
          [ngClass]="{ 'profile_information--tab--selected': tabSelected === 8 }"
          (click)="tabSelected = 8"
        >
          <span i18n="@@payment-tab">Payment</span>
        </div>
      }
    </div>
    @if (tabSelected === 0) {
      <app-profile-information-profile
        [user]="user"
        [form]="profileForm"
        [isEditable]="userProfileConfig.profile === profileConfigOption.Editable"
      >
      </app-profile-information-profile>
    }
    @if (tabSelected === 1) {
      <app-profile-information-address
        class="profile_information--tab-content"
        [user]="user"
        [addressForm]="addressForm"
        [isEditable]="userProfileConfig.address === profileConfigOption.Editable"
      >
      </app-profile-information-address>
    }
    @if (tabSelected === 2) {
      <app-profile-information-mi-default
        [miDefaultForm]="miDefaultForm"
        [userMIs]="userMIs"
        [isEditable]="userProfileConfig.miDefault === profileConfigOption.Editable"
      >
      </app-profile-information-mi-default>
    }
    @if (tabSelected === 3) {
      <app-profile-information-docs
        class="profile_information--tab-content"
        [user]="user"
        [docsForm]="docsForm"
        [isEditable]="userProfileConfig.documents === profileConfigOption.Editable"
      >
      </app-profile-information-docs>
    }
    @if (tabSelected === 4) {
      <app-profile-information-loyalty
        class="profile_information--tab-content"
        [user]="user"
        [loyaltiesForm]="loyaltiesForm"
        [isEditable]="userProfileConfig.loyalty === profileConfigOption.Editable"
      >
      </app-profile-information-loyalty>
    }
    @if (tabSelected === 5) {
      <app-profile-information-travel-preferences
        [user]="user"
        [travelPreferencesForm]="travelPreferencesForm"
        [isEditable]="userProfileConfig.travelPreferences === profileConfigOption.Editable"
      >
      </app-profile-information-travel-preferences>
    }
    @if (tabSelected === 6) {
      <app-profile-information-approval-reassignment
        [approver]="approver"
        [approvalReassignmentForm]="approvalReassignmentForm"
        [isEditable]="userProfileConfig.approvalReassignment === profileConfigOption.Editable"
      >
      </app-profile-information-approval-reassignment>
    }
    @if (tabSelected === 7) {
      <app-profile-information-approval
        [user]="user"
        [approvalForm]="approvalForm"
        [isEditable]="userProfileConfig.approvers === profileConfigOption.Editable"
      >
      </app-profile-information-approval>
    }
    @if (tabSelected === 8) {
      <app-profile-information-payment
        [user]="user"
        [isEditable]="userProfileConfig.payment === profileConfigOption.Editable"
      >
      </app-profile-information-payment>
    }
    <div class="footer">
      @if (tabSelected === 6) {
        <button
          [disabled]="
            !approvalReassignmentForm.get('approver').value?.id &&
            !approvalReassignmentForm.get('validTo').value
          "
          appButton="small"
          (click)="clearApprovalReassignment()"
          i18n="@@Clear"
        >
          Clear
        </button>
      }
      @if (tabSelected !== 8 && tabSelected !== 2) {
        <button
          type="button"
          appButton="small"
          [disabled]="checkFormValidation()"
          (click)="editUser()"
          i18n="@@Save"
        >
          Save
        </button>
      }
    </div>
  </div>
}
